export default {
  categoryNames(s, names) {
    s.categoryNames = names.slice();
  },

  typeaheadResults(s, value) {
    s.typeaheadResults = value;
  },

  authenticated(s, value) {
    s.authenticated = value;
  },

  user(s, value) {
    s.user = value;
  },

  locale(s, value) {
    localStorage.locale = value;
    s.locale = value;
  },

  notify(s, value) {
    s.notify = value;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js